import React, { useContext, useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import "../../cssfiles/homepage.css";
import { ThemeContext } from "../Homepage";
import LK_Loading from "../../images/LK_Loading.gif";
import CustomToast from "../CommonComponents/CustomToast";
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomTimePicker from "../CommonComponents/CustomTimePicker";
import {
  saveStorage,
  getStorage,
  getStoragePeriodList,
} from "../../Restclient/datacollection";

export default function StoragePeriod() {
  const [required, setRequired] = React.useState(0);
  const [saveStatus, setSaveStatus] = React.useState(0);
  const [storage, setStorage] = React.useState({
    rawDataStoragePeriod: "",
    aggreatedDataStoragePeriod: "",
    dayStartTime: null,
  });
  const [storagePeriodList, setStoragePeriodList] = React.useState({
    rawDataStoragePeriodList: [],
    aggreatedDataStoragePeriodList: [],
  });
  const [loading, setLoading] = useState(1);
  const [disableButtons, setDisableButtons] = useState(99);
  const [storageOG, setStorageOG] = useState({
    rawDataStoragePeriod: "",
    aggreatedDataStoragePeriod: "",
    dayStartTime: null,
  });
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    setDisableButtons(0);
    getStorage(getStorageCallback);
    getStoragePeriodList(getStoragePeriodListCallback);
    setLoading(1);
  }, []);

  function getStorageCallback(res) {
    if (res.status === 200 && res.data.type === "success") {
      let obj = {};
      if (res.data.data !== null && res.data.data !== undefined) {
        obj.aggreatedDataStoragePeriod =
          res.data.data.AggreatedDataStoragePeriod;
        obj.dayStartTime = res.data.data.DayStartTime;
        obj.rawDataStoragePeriod = res.data.data.RawDataStoragePeriod;
      }
      setStorage(obj);
      setStorageOG({ ...obj });
    } else if (res.status === 500) {
      // pop for error
    }
    setLoading(0);
    setDisableButtons(0);
  }

  function getStoragePeriodListCallback(res) {
    if (res.status === 200 && res.data.type === "success") {
      let obj = { ...storagePeriodList };
      obj.aggreatedDataStoragePeriodList =
        res.data.data.aggregatedDataPeriodList;
      obj.rawDataStoragePeriodList = res.data.data.rawDataPeriodList;
      setStoragePeriodList(obj);
    } else if (res.status === 500) {
      // pop for error
    }
    setLoading(0);
    setDisableButtons(0);
  }

  function handleToastClose() {
    setSaveStatus(0);
  }

  function handleRawDataStoragePeriod(val) {
    let temp = { ...storage };
    temp.rawDataStoragePeriod = val;
    setStorage(temp);
  }

  function handleAggreatedDataStoragePeriod(val) {
    let temp = { ...storage };
    temp.aggreatedDataStoragePeriod = val;
    setStorage(temp);
  }

  function handleDayStartTime(val) {
    let temp = { ...storage };
    temp.dayStartTime = val;
    setStorage(temp);
  }

  function handleSaveStorage() {
    if (
      storage.rawDataStoragePeriod === "" ||
      storage.aggreatedDataStoragePeriod === "" ||
      storage.dayStartTime === ""
    ) {
      setRequired(1);
    } else {
      saveStorage(storage, saveStoragecallback);
      setLoading(1);
    }
    setDisableButtons(1);
  }

  function saveStoragecallback(res) {
    if (res.status === 200 && res.data.type === "success") {
      setSaveStatus(1);
      setStorageOG({ ...storage });
    } else if (res.status === 500) {
      // pop for error
      setSaveStatus(2);
    }
    setDisableButtons(0);
    setLoading(0);
  }

  function handleCloseStorage() {
    setStorage({ ...storageOG });
    setDisableButtons(0);
  }

  return (
    <Box
      className="compliance-config"
      sx={{ height: "100%", boxSizing: "border-box", width: "100%" }}
    >
      {saveStatus != 0 ? (
        <CustomToast
          openToast={saveStatus != 0}
          type={saveStatus == 1 ? "Success" : "Error"}
          autoHideDuration={10000}
          toastText={saveStatus == 1 ? "Saved Successfully!" : "Save Failed"}
          onClose={handleToastClose}
        />
      ) : (
        <></>
      )}
      {loading === 1 ? (
        <>
          <Box
            sx={{
              gap: "8px",
              boxSizing: "border-box",
              height: "calc(100%)",
              width: "100%",
              overflow: "auto",
              alignContent: "center",
            }}
          >
            <img
              src={LK_Loading}
              alt="loading..."
              style={{ height: "15%", width: "auto", alignSelf: "center" }}
            />
          </Box>
        </>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "100%",
              boxSizing: "border-box",
              overflow: "hidden",
            }}
          >
            <Box
              className="config-form-box"
              sx={{
                padding: "0px",
                gap: "8px",
                width: "100%",
                boxSizing: "border-box",
                height: "7%",
                margin: 0,
              }}
            >
              <Box sx={{ flexGrow: 1 }}></Box>
              <CustomCancelButton
                onClick={handleCloseStorage}
                buttonText={"Cancel"}
              ></CustomCancelButton>
              <CustomButton
                /*id={deviceInfo.id}*/ onClick={handleSaveStorage}
                buttonText={"Save"}
                width={"12px"}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                boxSizing: "border-box",
                padding: "8px",
                background: "var(--PrimaryBackground)",
                paddingBottom: "12px",
                height: "93%",
              }}
            >
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    minWidth: "308px",
                  }}
                >
                  Raw Data StoragePeriod (Months)
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomDropDown
                  options={storagePeriodList.rawDataStoragePeriodList}
                  onChange={handleRawDataStoragePeriod}
                  disabled={false}
                  defaultValue={storage.rawDataStoragePeriod}
                  width={264}
                ></CustomDropDown>
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    minWidth: "308px",
                  }}
                >
                  Aggreated Data Storage Period (Months)
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomDropDown
                  options={storagePeriodList.aggreatedDataStoragePeriodList}
                  onChange={handleAggreatedDataStoragePeriod}
                  disabled={false}
                  defaultValue={storage.aggreatedDataStoragePeriod}
                  width={264}
                ></CustomDropDown>
              </Box>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: theme === "dark" ? "#C1C1C1" : "#3C3C3C",
                    minWidth: "308px",
                  }}
                >
                  Day Start Time
                  <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                </Typography>
                <CustomTimePicker
                  id={"dayStartTime"}
                  ampm={false}
                  onChange={handleDayStartTime}
                  views={["hours", "minutes", "seconds"]}
                  timeSteps={{ hours: 1, minutes: 5, seconds: 30 }}
                  width={264}
                  defaultValue={storage.dayStartTime}
                />
              </Box>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}
